export const fixedCacheKeys = {
  LOGIN: "user-login-post",
  SEND_OTP: "user-otp-post",
  VERIFY_OTP: "user-verify-post",
  LOGOUT: "user-verify-get",
  FORGOT_PASSWORD: "user-forgotPassword-post",
  RESET_PASSWORD: "user-resetPassword-post",
  EDIT_PROFILE: "user-profileData-Post",
  FILE_UPLOAD: "user-File-post",
  CHANGE_PASSWORD: "user-changePassword-post",
  DELETE_PROFILE: "user-deleteProfile-delete",
  ADD_META_DATA: "user-addMetaData-post",
  EDIT_META_DATA: "user-editMetaDta-put",
  EDIT_SITE_SETTING_DATA: "user-editSiteSettingData-put",
  EDIT_ANALYTICAL_DATA: "user-editAnalyticalData-put",
  ADD_SITE_DATA: "user-addSiteData-Post",
  ADD_ANALYTICAL_DATA: "user-addAnalyticalData-post",
  ADD_MAINTENANCE_DATA: "user-editMaintenanceData-post",
  EDIT_MAINTENANCE_DATA: "user-editMaintenanceData-put",
  DATE_TIME: "user-dateTime-Post",
  EDIT_DATE_TIME: "user-dateTime-put",
  ADD_SOCIAL_MEDIA_SDK: "user-addSocialMediaSdk-post",
  EDIT_SOCIAL_MEDIA_SDK: "user-editSocialMediaSdk-put",
  ADD_SOCIAL_MEDIA_LINK: "user-addSocialMediaLink-post",
  EDIT_SOCIAL_MEDIA_LINK: "user-editSocialMediaLink-put",
  CHANGE_STATUS: "user-changeStatus-post",
  ADD_SMTP_DETAILS: "user-addSmtpDetails-post",
  EDIT_SMTP_DETAILS: "user-editSmtpDetails-put",
  NOTIFICATION_STATUS: "setting-notificationStatus-post",
  TIMEZONE_LIST: "country-timezoneList-post",
  TIMEZONE_DELETE: "country-timeZoneData-delete",
  ADD_TIMEZONE: "country-addTimezone-post",
  TIMEZONE_CHANGE_STATUS: "timezone-changeStatus-post",
  ADD_ROLE: "role-addRole-post",
  EDIT_ROLE: "role-editRole-put",
  ROLE_LIST: "role-roleList-post",
  CHANGE_ROLE: "role-changeRole-patch",
  DELETE_ROLE: "role-deleteRole-delete",
  USER_LIST: "role-usersList-get",
  EMAIL_TEMPLATES_LISTINGS: "email-emailTemlates-post",
  EMAIL_TEMPLATES_STATUS_CHANGE: "email-emailTemplatesStatus-post",
  EMAIL_TEMPLATES_DELETE: "email-emailTemplatesDelete-delete",
  EMAIL_TEMPLATES_ADD: "email-addEmailTemplates-post",
  EMAIL_TEMPLATES_EDIT: "email-editEmailTemplates-post",

  //adminUser
  ADMIN_USER_DATA: "users-adminUsersData-post",
  ADD_ADMIN_USER_DATA: "users-addAdminUsersData-post",
  EDIT_ADMIN_USER_DATA: "users-editAdminUsersData-put",
  DELETE_ADMIN_USER_DATA: "users-deleteAdminUsersData-delete",
  ADMIN_USER_DETAILS_DOWNLOAD: "users-adminusersDownload-get",
  //User data
  USER_DATA: "users-UsersData-get",
  ADD_USER_DATA: "users-addUsersData-post",
  USER_REVOKE_SUSPENSION: "user-suspensionData-post",
  EDIT_USER_DATA: "users-editusersData-put",
  DELETE_USER_DATA: "users-deleteUsersData-delete",
  CHANGE_USER_STATUS: "users-changeUsersStatus-post",
  CHANGE_APP_USER_PASSWORD: "users-changeAppUserPassword-post",
  STATUS_ADMIN_USER_DATA: "users-statusAdminUsersData-post",
  USER_DETAILS_DOWNLOAD: "users-userDetailsDownload-get",

  //Parient
  PATIENT_DETAILS_DOWNLOAD: "patient-download-post",
  //report user
  REPORT_USER_DATA: "report-users-ReportUsersData-get",
  REPORT_USER_DOWNLOAD_DATA: "report-users-download-post",
  REPORT_USER_CANCEL_SUSPENSION: "report-users-cancel-suspension-post",
  REPORT_USER_SUSPEND: "report-users-suspend",
  REPORT_USER_REVOKE_SUSPENSION: "user-management/users/revoke-suspension",

  //static page
  STATIC_PAGE_LISTING: "static-staticPageListing-post",
  STATIC_PAGE_CHANGE_STATUS: "static-staticPageChangeStatus-post",
  ADD_STATIC_PAGES: "static-addStaticPages-post",
  EDIT_STATIC_PAGES: "static-editStaticPages-post",
  DELETE_STATIC_PAGES: "static-deleteStaticPages-delete",
  STATIC_PAGE_LIST_DOWNLAOD: "static-staticpageDownload-get",
  //filter
  SAVE_FILTER_DATA: "filter-saveFilter-post",
  GET_FILTER_DATA: "filter-getFilter-post",
  DELETE_FILTER_DATA: "filter-deleteFilter-delete",
  SAVE_COLUMN_DATA: "column-saveColumn-post",
  GET_COLUMN_DATA: "column-getColumn-post",
  DELETE_COLUMN_DATA: "column-deleteColumn-delete",
  //support
  SUPPORT_LISTING: "support-getSupportList-get",
  GENDER_SUPPORT_LISTING: "gender-genderSupportList-get",
  CITY_SUPPORT_LISTING: "city-city-support-listing-get",
  SUPPORT_DELETE: "support-deleteSupport-delete",
  SUPPORT_STATUS: "support-ticketStatus-patch",
  SUPPORT_ADD_DATA: "support-addSupportData-post",
  SUPPORT_EDIT_DATA: "support-editReplyData-put",
  SUPPORT_REPLY_DELETE: "support-deleteReplyData-delete",

  //master gender
  ADD_EDIT_TERRITORY: "add-edit-territory-post",
  TERRITORY_LIST_DATA: "territory-data-get",
  PAGE_TITLE_ADD_DATA: "page-title-post",
  PAGE_TITLE_EDIT_DATA: "page-title-patch",
  PAGE_TITLE_LISTING: "page-title-List-get",
  PAGE_TITLE_DELETE: "page-title-delete",
  PAGE_TITLE_STATUS_CHANGE: "page-title-statuschange-put",

  //Questionnaire
  ADD_QUESTIONNAIRE: "question-post",
  GET_QUESTIONNAIRE: "question-get",
  DELETE_QUESTIONNAIRE: "question-delete",
  EDIT_QUESTIONNAIRE: "question-edit",

  // Dashboard
  GETSTATICSLIST: "statics-getStaticsList-data",
  GET_BAR_GRAPH_LIST: "statics-getBargraphList-data",
  GET_REPORT_DOWNLOAD: "statics-reportsDownload-get",
  GET_LINE_GRAPH_LIST: "statics-getline-graphlist-data",

  //Wound Management
  GET_VISIT_LIST: "visit-list-get",
  GET_WOUND_LIST: "wound-list-get",

  //notAssessReason
  NOT_ASSESS_REASON_LISTING: "not-assess-reason-listing-get",
  NOT_ASSESS_REASON_ADD_DATA: "not-assess-reason-add-data-post",
  NOT_ASSESS_REASON_EDIT_DATA: "not-assess-reason-edit-data-put",
  NOT_ASSESS_REASON_DELETE: "not-assess-reason-delete-data-delete",
  NOT_ASSESS_REASON_STATUS_CHANGE: "not-assess-reason-status-change-put",
  NOT_ASSESS_REASON_DETAILS: "not-assess-reason-details-get",

  //Etiology
  ETIOLOGY_LISTING: "etiology-listing-get",
  ETIOLOGY_ADD_DATA: "etiology-add-data-post",
  ETIOLOGY_EDIT_DATA: "etiology-edit-data-put",
  ETIOLOGY_DELETE: "etiology-delete-data-delete",
  ETIOLOGY_STATUS_CHANGE: "etiology-status-change-put",
  ETIOLOGY_DETAILS: "etiology-details-get",

  PAGE_TITLE_SWAP: "page-title-swap-put",
  TITLE_DROPDOWN_LIST: "title-dropdown-list-get",
};
